<script setup lang="ts">
    import { onMounted } from 'vue';
    import { useHipSpineXRayModalViewModel } from '@/views/3d-planner/hipSpine/xrayModal/useHipSpineXRayModalViewModel';
    import HipSpineXRayPanel from '@/views/3d-planner/hipSpine/components/HipSpineXRayPanel.vue';
    import HipSpineAnglesAnnotationsPanel from '@/views/3d-planner/hipSpine/components/HipSpineAnglesAnnotationsPanel.vue';
    import SaveStatusIndicator from '@/components/SaveStatusIndicator.vue';
    import { useHipSpineAnnotationHelpViewModel } from '@/views/3d-planner/hipSpine/annotationHelp/useHipSpineAnnotationHelpViewModel';
    import HipSpineAnnotationHelpPanel from '@/views/3d-planner/hipSpine/components/HipSpineAnnotationHelpPanel.vue';

    const emit = defineEmits<{ closeModal: [] }>();
    const vm = useHipSpineXRayModalViewModel();
    const helpVm = useHipSpineAnnotationHelpViewModel();

    // Always open on the Annotations tab (preserves prior onMounted behaviour).
    onMounted(() => vm.resetPanelView());

    function closeModal() {
        helpVm.closeHelp();
        emit('closeModal');
    }
</script>

<template>
    <v-card class="hip-spine-modal">
        <div class="container">
            <save-status-indicator :state="vm.saveStatus" class="save-status" />
            <div class="close" @click="closeModal">
                <v-icon>mdi-close</v-icon>
            </div>
            <v-card-title class="text-center pb-0 font-weight-medium title">
                Landmarks Adjustments Menu
            </v-card-title>
            <div class="d-flex align-start justify-space-between">
                <HipSpineXRayPanel />
                <HipSpineAnglesAnnotationsPanel />
            </div>
            <HipSpineAnnotationHelpPanel v-if="helpVm.openCategory" class="help-dock" />
        </div>
    </v-card>
</template>

<style scoped lang="scss">
    .hip-spine-modal {
        padding: 10px;
        border-radius: 17px;
        position: fixed;
        top: 30px;
        left: 390px;
        width: 860px;
        box-shadow:
            0 59px 69px 0 rgba(0, 0, 0, 0.01),
            0 44px 58px 0 rgba(0, 0, 0, 0.05),
            0 6px 38px 0 rgba(0, 0, 0, 0.04),
            0 11px 24px 0 rgba(0, 0, 0, 0.1);
        z-index: 1;
        height: calc(100vh - 168px);
        overflow: visible;
    }

    .container {
        position: relative;
    }

    .help-dock {
        position: absolute;
        top: -10px;
        left: 100%;
        margin-left: 12px;
        width: 300px;
        z-index: 2;
    }

    .title {
        font-size: 16px;
    }

    .save-status {
        position: absolute;
        top: 8px;
        right: 44px;
        z-index: 2;
    }

    .close {
        position: absolute;
        top: 0;
        right: 0;
        padding: 6px;
        border-radius: 50%;
        cursor: pointer;
    }

    @media screen and (max-width: 1500px) {
        .hip-spine-modal {
            left: 20vw;
        }
    }

    @media screen and (max-width: 1300px) {
        .hip-spine-modal {
            left: 10vw;
        }
    }
</style>
